import { Context, useContext } from 'react';
import { IDialogController } from '@/shared/dialog/informDialog';
import { GlobalInformDialogContext } from '@/shared/globalInformDialog.context';

export const useInformDialog = (
  DialogContext: Context<IDialogController> = GlobalInformDialogContext,
): IDialogController => {
  return useContext<IDialogController>(DialogContext);
};
